import * as React from "react";
import { Grid } from "@material-ui/core";
import { SummarizeColumnsCreated } from "./summarize-columns-created";
import { SummarizeColumnsUpdated } from "./summarize-columns-updated";
import { SummarizeDoorsWithUnitsDisabled } from "./summarize-doors-disabled-with-units";
import { SummarizeDoorsWithUnitsEnabled } from "./summarize-doors-enabled-with-units";
import { SummarizeDoorsTurnedOnOrOff } from "./summarize-doors-turned-on-or-off";

interface ISummarizeChangesProps {
    wasUpdated: boolean;
    columnsToCreate: string[];
    columnsToUpdate: string[];
    doorsForDisableOrEnable: string[];
    doorsForEnableWithUnits: string[];
    doorsForDisableWithUnits: string[];
}

export const SummarizeChanges: React.FC<ISummarizeChangesProps> = ({
    wasUpdated,
    columnsToCreate,
    columnsToUpdate,
    doorsForDisableOrEnable,
    doorsForDisableWithUnits,
    doorsForEnableWithUnits,
}) => {
    const hasDoorsForEnableWithUnits = !!doorsForEnableWithUnits.length;
    const hasDoorsForDisableWithUnits = !!doorsForDisableWithUnits.length;

    return (
        <Grid direction="column" container spacing={2}>
            {!!columnsToCreate.length && (
                <Grid item>
                    <SummarizeColumnsCreated items={columnsToCreate} wasUpdated={wasUpdated} />
                </Grid>
            )}

            {!!columnsToUpdate.length && (
                <Grid item>
                    <SummarizeColumnsUpdated items={columnsToUpdate} wasUpdated={wasUpdated} />
                </Grid>
            )}

            {!!doorsForDisableOrEnable.length && (
                <Grid item>
                    <SummarizeDoorsTurnedOnOrOff items={doorsForDisableOrEnable} wasUpdated={wasUpdated} />
                </Grid>
            )}

            {!!hasDoorsForEnableWithUnits && (
                <Grid item>
                    <SummarizeDoorsWithUnitsEnabled items={doorsForEnableWithUnits} wasUpdated={wasUpdated} />
                </Grid>
            )}

            {!!hasDoorsForDisableWithUnits && (
                <Grid item>
                    <SummarizeDoorsWithUnitsDisabled items={doorsForDisableWithUnits} wasUpdated={wasUpdated} />
                </Grid>
            )}
        </Grid>
    );
};
